import { render, staticRenderFns } from "./ResetPasswordFormComponent.vue?vue&type=template&id=d9b28d0a"
import script from "./ResetPasswordFormComponent.vue?vue&type=script&lang=js"
export * from "./ResetPasswordFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports